import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { NovaGto } from '../../base/vo/nova-gto';
import { isNullOrUndefined } from 'util';
import { NovaGtoService } from '../nova-gto.service';
import { Subscription }   from 'rxjs';

@Component({
  selector: 'app-resumo',
  templateUrl: './resumo.component.html',
  styleUrls: ['./resumo.component.css']
})
export class ResumoComponent implements OnInit, OnDestroy {

  @Input() novaGto: NovaGto;
  @Output() stepControl: EventEmitter<NovaGto> = new EventEmitter<NovaGto>();
  displayModalEnviarGto: boolean = false;
  private subscriptionIsEnviandoGto: Subscription;
  public isEnviando: boolean = false;
  
  constructor(private novaGtoService: NovaGtoService,) {
  	this.subscriptionIsEnviandoGto = this.novaGtoService.isEnviandoGto.subscribe(value => {
	    this.isEnviando = value;
	})
  }

  ngOnInit() {
  }
  
  ngOnDestroy() {
	this.subscriptionIsEnviandoGto.unsubscribe();
  }

  abrirModalGtoDialog(){
    this.displayModalEnviarGto = true;    
  }

  fecharModal(){
    this.displayModalEnviarGto = false;
  }

  enviarNovaGto() {
    this.displayModalEnviarGto = false;
    let novaGto = new NovaGto();
    novaGto = this.novaGto;
    this.isEnviando = true;
    this.stepControl.emit(novaGto);      
  }

  faces(facesList){
    var codigo = ''

    facesList.forEach(element => {
      codigo += element.codigo + ', ';
    });
    codigo = codigo.slice(0, -2);
    
    return codigo;
  }

  private getQtdeAnexos(param: any): number{
    if(isNullOrUndefined(param)){
      return 0;
    }else{
      return param.length;
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/components/nova-gto/resumo/resumo.component.ts